import React from 'react';
import { CTAButton } from './CTAButton';
export const StickyCTA = () => {
  return <div className="fixed bottom-0 left-0 right-0 bg-white shadow-lg border-t border-gray-200 py-2 sm:py-3 z-50" data-id="element-219">
      <div className="max-w-3xl mx-auto px-4 flex flex-col sm:flex-row justify-between items-center" data-id="element-220">
        <div className="mb-2 sm:mb-0 sm:mr-4 text-center sm:text-left" data-id="element-221">
          <p className="font-bold text-base sm:text-lg" data-id="element-222">
            50% OFF - Limited Time
          </p>
          <p className="text-red-600 text-xs sm:text-sm" data-id="element-223">
            Only 500 units available!
          </p>
        </div>
        <CTAButton data-id="element-224" />
      </div>
    </div>;
};